<!--财务报价-->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('运费计算')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-card shadow="never" style="margin-bottom: 5px;">
            <el-form inline>
                <el-row :gutter="10">
                    <el-col :span="6">
                        <el-form-item :label="msg('来源报价')" style="margin-bottom:0;">
                            <el-select v-model="offerId" size="mini" style="width: 260px;"
                                placeholder=" "
                                @change="onOfferChange">
                                <el-option
                                    v-for="o in offers"
                                    :key="o.id"
                                    :label="o.used===1||o.used==='1'
                                        ? (o.name || '') + ' (' + msg('默认') + ')'
                                        : (o.name || '')"
                                    :value="o.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="msg('录重时间')" style="margin-bottom:0;">
                            <el-date-picker
                                v-model="query.Date"
                                type="daterange"
                                :range-separator="msg('至')"
                                value-format="yyyy-MM-dd"
                                size="mini"
                                style="width: 240px;">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item :label="msg('结算账号')" style="margin-bottom:0;">
                            <el-input
                                v-model="query.settleAccounts"
                                type="textarea"
                                :rows="3"
                                size="mini"
                                clearable
                                :placeholder="msg('请输入结算账号')"
                                style="width: 100%;">
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4" style="margin-top: 7px;">
                        <el-button type="primary" icon="el-icon-search" size="mini" :loading="computing" :disabled="computing" @click="load">{{msg('执行计算')}}</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <el-card shadow="never" style="margin-bottom: 14px;">
            <el-row :gutter="15">
                <el-table :data="results" :height="docHeight" style="width: 100%" size="mini" ref="dataTable" stripe show-summary :summary-method="getSummaries">
                    <el-table-column type="index" width="50"></el-table-column>
                    <el-table-column prop="settleAccount" :label="msg('结算账号')" min-width="180" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="total" :label="msg('总数')" min-width="180" align="right">
                        <template slot-scope="scope">
                            <span style="color:#303133; font-weight:600;">{{ scope.row.total || 0 }}</span>
                            <span class="xsmall">单</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="success" :label="msg('计算成功')" min-width="180" align="right">
                        <template slot-scope="scope">
                            <span style="color:#67C23A;">{{ scope.row.success || 0 }}</span>
                            <span class="xsmall">({{ rowRatio(scope.row, true) }})</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fail" :label="msg('计算失败')" min-width="180" align="right">
                        <template slot-scope="scope">
                            <span :style="{color: (scope.row.fail||0) > 0 ? '#F56C6C' : '#909399'}">{{ scope.row.fail || 0 }}</span>
                            <span class="xsmall">({{ rowRatio(scope.row, false) }})</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalFee" :label="msg('总费用(元)')" min-width="180" align="right">
                        <template slot-scope="scope">
                            <span style="color:#1f2d3d; font-weight:600;">¥ {{ format2(scope.row.totalFee) }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-card>
    </div>
</template>
<script>
export default {
    name: 'FinanceCompute',
    components: {},
    data(){
        return {
            results: [],
            query: { username: '', Date: null, startDate: null, endDate: null, settleAccounts: '' },
            offers: [],
            offerId: null,
            offer: null,
            computing: false,
            timers: [],
        }
    },
    computed: {
        docHeight() {
            var height = this.$store.state.docHeight || 0;
            return Math.max(240, height - 220);
        },
        isMinScreen() {
            return !!this.$store.state.isMinScreen;
        },
    },
    mounted(){
        this.init();
        this.loadOffers();
    },
    destroyed(){
        this.clearTimers();
    },
    methods:{
        init(){
            this.results = [];
            this.offers = [];
            this.offerId = null;
            this.offer = null;
            this.computing = false;
            this.clearTimers();
        },
        clearTimers(){
            (this.timers || []).forEach(id => clearInterval(id));
            this.timers = [];
        },
        loadOffers(){
            this.$axios.post(this.$kit.api.financeOffer.list, { page:1, pageSize: 100 })
                .then((result) => {
                    if(!result || !result.status) return;
                    let rows = (result.data && result.data.list) ? result.data.list : [];
                    this.offers = rows || [];
                    let def = null;
                    if(this.offers && this.offers.length > 0){
                        def = this.offers.find(o => o.used===1 || o.used==='1');
                        if(!def){
                            let maxId = -1;
                            this.offers.forEach(o => {
                                const id = Number(o.id) || 0;
                                if(id > maxId){ maxId = id; def = o; }
                            });
                        }
                    }
                    if(def){
                        this.offerId = Number(def.id);
                        this.offer   = def;
                    }
                });
        },
        onOfferChange(val){
            const id = Number(val);
            const found = (this.offers||[]).find(o => Number(o.id)===id);
            this.offer = found || null;
        },
        doSearch(){
            this.results = [];
            var q = Object.assign({}, this.query);
            if(Array.isArray(q.Date) && q.Date.length === 2){
                q.startDate = q.Date[0];
                q.endDate   = q.Date[1];
            }
            delete q.Date;
        },
        load(){
            if(this.computing || (this.timers && this.timers.length > 0)){
                this.$message(this.msg('计算中，请稍候'));
                return;
            }
            if(!this.offerId){
                this.$message(this.msg('请选择一份报价'));
                return;
            }
            if(!Array.isArray(this.query.Date) || this.query.Date.length !== 2){
                this.$message(this.msg('请选择录重时间'));
                return;
            }
            var q = Object.assign({}, this.query);
            q.offerId = Number(this.offerId);
            if(Array.isArray(q.Date) && q.Date.length === 2){
                q.startDate = q.Date[0];
                q.endDate   = q.Date[1];
            }
            delete q.Date;
            // 结算账号：按逗号/换行拆成数组，过滤空串
            if(q.settleAccounts){
                q.settleAccounts = q.settleAccounts.split(/[\r\n,]+/).filter(s => s.trim());
            }else{
                q.settleAccounts = [];
            }

            this.$confirm(this.msg('确认进行运费计算？'), this.msg('提示'), {
                confirmButtonText: this.msg('是'),
                cancelButtonText: this.msg('否'),
                type: 'warning',
            }).then(() => {
                this.doCompute(q);
            }).catch(() => {});
        },
        doCompute(q){
            this.computing  = true;
            this.results    = [];
            this.clearTimers();
            this.$axios.post(this.$kit.api.financeCompute.compute, q).then((result) => {
                if(!result || !result.status){
                    this.computing = false;
                    this.$message(result.msg || this.msg('计算失败'));
                    return;
                }
                // 后端异步启动计算，前端开始轮询进度
                this.startPolling();
            }).catch(() => {
                this.computing = false;
            });
        },
        /**
         * 轮询计算进度：每5秒查询一次，直到全部完成或达到最大次数
         */
        startPolling(){
            const POLL_INTERVAL = 5000;       // 5秒轮询一次
            const MAX_POLL_COUNT = 1440;      // 最大轮询次数（1440 × 5秒 = 2小时兜底）
            let pollCount = 0;

            const timer = setInterval(() => {
                pollCount++;
                this.$axios.post(this.$kit.api.financeCompute.progress).then((result) => {
                    if(!result || !result.status) return;
                    const data = result.data || {};
                    // 全量替换已完成账号的快照（后端每次返回完整的已完成列表）
                    this.results = Array.isArray(data.results) ? data.results : [];

                    if(data.finished){
                        // 全部完成：停止轮询、清理后端进度、恢复按钮状态
                        clearInterval(timer);
                        this.timers = this.timers.filter(t => t !== timer);
                        this.computing = false;
                        this.$axios.post(this.$kit.api.financeCompute.finish).catch(() => {});
                        this.$message.success(this.msg('计算完成'));
                        return;
                    }

                    // 超过最大轮询次数仍未完成：强制停止，提示用户
                    if(pollCount >= MAX_POLL_COUNT){
                        clearInterval(timer);
                        this.timers = this.timers.filter(t => t !== timer);
                        this.computing = false;
                        this.$message.warning(this.msg('计算超时，请稍后在进度中查看结果'));
                    }
                }).catch(() => {
                    // 单次请求失败：忽略，下次继续轮询
                });
            }, POLL_INTERVAL);

            this.timers.push(timer);
        },
        rowRatio(row, isSuccess){
            const t = Number(row.total) || 0;
            if(t <= 0) return '-';
            const v = isSuccess ? (Number(row.success) || 0) : (Number(row.fail) || 0);
            return (v * 100 / t).toFixed(1) + '%';
        },
        format2(v){
            if(v === null || v === undefined || v === '') return '0.00';
            const num = Number(v);
            if(!isFinite(num)) return '0.00';
            // 与后端 toDouble 行为一致：2 位小数，直接截断（RoundingMode.DOWN），避免 JS toFixed 的四舍五入
            return (Math.floor(num * 100) / 100).toFixed(2);
        },
        getSummaries(param){
            const { columns, data } = param;
            const len = columns.length;
            const sums = [];
            columns.forEach((col, i) => {
                if(i === 0){
                    sums[i] = this.msg('合计');
                    return;
                }
                if(col.property === 'settleAccount'){
                    const totalAccounts = (data || []).length;
                    sums[i] = this.msg('账号') + '：' + totalAccounts;
                    return;
                }
                if(col.property === 'total'){
                    const total = (data || []).reduce((a, b) => a + (Number(b.total) || 0), 0);
                    sums[i] = this.msg('订单总数') + '：' + total;
                    return;
                }
                if(col.property === 'success'){
                    const total = (data || []).reduce((a, b) => a + (Number(b.success) || 0), 0);
                    const grandTotal = (data || []).reduce((a, b) => a + (Number(b.total) || 0), 0);
                    const pct = grandTotal > 0 ? (total * 100 / grandTotal).toFixed(1) + '%' : '-';
                    sums[i] = this.msg('成功总数') + '：' + total + ' (' + pct + ')';
                    return;
                }
                if(col.property === 'fail'){
                    const total = (data || []).reduce((a, b) => a + (Number(b.fail) || 0), 0);
                    const grandTotal = (data || []).reduce((a, b) => a + (Number(b.total) || 0), 0);
                    const pct = grandTotal > 0 ? (total * 100 / grandTotal).toFixed(1) + '%' : '-';
                    sums[i] = this.msg('失败总数') + '：' + total + ' (' + pct + ')';
                    return;
                }
                if(col.property === 'totalFee'){
                    const total = (data || []).reduce((a, b) => a + (Number(b.totalFee) || 0), 0);
                    sums[i] = this.msg('总费用合计') + '：¥ ' + this.format2(total);
                    return;
                }
                sums[i] = '';
            });
            return sums;
        },
    }
}
</script>
<style lang="scss" scoped>
.xlabel{color:#606266;}
.xtext{color:#303133;}
.xsmall{color:#909399; font-size:12px; margin-left:6px;}
</style>
